import React from 'react';
import { AdminLayout } from '../components/AdminLayout';
import { CrmManager } from '../components/CrmManager';

export const AdminCrmPage: React.FC = () => {
  return (
    <AdminLayout>
      <CrmManager />
    </AdminLayout>
  );
};
